import { render, staticRenderFns } from "./TumSonuclar.vue?vue&type=template&id=cb06b5a6&"
import script from "./TumSonuclar.vue?vue&type=script&lang=js&"
export * from "./TumSonuclar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports